(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["divine-pricelist"] && !Shopify.designMode) return;
  try {
    
  class DivinePricelistNav extends HTMLElement {
    #links = [];
    #targets = [];
    #current = -1;
    #frame = 0;
    #onScroll = () => {
      if (this.#frame) return;
      this.#frame = requestAnimationFrame(() => {
        this.#frame = 0;
        this.#update();
      });
    };

    connectedCallback() {
      this.#links = [...this.querySelectorAll('a[href^="#"]')];
      this.#targets = this.#links.map((link) => document.getElementById(decodeURIComponent(link.hash.slice(1))));
      if (this.#targets.every((target) => target === null)) return;
      // Capture phase: the page may scroll inside a wrapper element, not the window.
      document.addEventListener('scroll', this.#onScroll, { passive: true, capture: true });
      window.addEventListener('resize', this.#onScroll, { passive: true });
      this.#update();
    }

    disconnectedCallback() {
      document.removeEventListener('scroll', this.#onScroll, { capture: true });
      window.removeEventListener('resize', this.#onScroll);
      if (this.#frame) cancelAnimationFrame(this.#frame);
    }

    /** The current category is the last one whose top has passed under the sticky bar. */
    #update() {
      const line = this.getBoundingClientRect().bottom + 48;
      let index = 0;
      for (const [position, target] of this.#targets.entries()) {
        if (target && target.getBoundingClientRect().top <= line) index = position;
      }
      if (index === this.#current) return;
      this.#current = index;

      for (const [position, link] of this.#links.entries()) {
        if (position === index) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      }

      // Move only the row of buttons sideways, in order, so the current one stays in view.
      const list = this.querySelector('ul');
      const item = this.#links[index]?.parentElement;
      if (!list || !item || list.scrollWidth <= list.clientWidth) return;
      list.scrollTo({ left: item.offsetLeft - (list.clientWidth - item.offsetWidth) / 2, behavior: 'smooth' });
    }
  }

  if (!customElements.get('divine-pricelist-nav')) customElements.define('divine-pricelist-nav', DivinePricelistNav);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["divine-reels"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('divine-reels')) {
    customElements.define('divine-reels', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.divine-reels__track');
        this.step = Number(this.dataset.step) || 8;
        this.arrows = this.querySelectorAll('[data-reel-step]');

        this.querySelector('[data-reel-more]')?.addEventListener('click', (event) => this.more(event.currentTarget));
        this.track.addEventListener('click', (event) => {
          const sound = event.target.closest('[data-reel-sound]');
          if (sound) this.toggleSound(sound);
        });
        this.arrows.forEach((arrow) => arrow.addEventListener('click', () => {
          const card = this.track.querySelector('.divine-reels__item:not([hidden])');
          const gap = parseFloat(getComputedStyle(this.track).columnGap || '0');
          const width = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
          this.track.scrollBy({ left: width * Number(arrow.dataset.reelStep), behavior: 'smooth' });
        }));
        this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
        this.updateArrows();

        this.motion = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            if (this.motion || !video.muted) video.play().catch(() => {});
          } else {
            video.pause();
          }
        }), { threshold: [0, 0.6] });
        this.watch();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      watch() {
        this.querySelectorAll('.divine-reels__item:not([hidden]) video').forEach((video) => this.observer.observe(video));
      }

      more(button) {
        const hidden = [...this.querySelectorAll('.divine-reels__item[hidden]')];
        hidden.slice(0, this.step).forEach((item) => item.removeAttribute('hidden'));
        if (hidden.length <= this.step) button.closest('li').remove();
        this.watch();
        this.updateArrows();
      }

      toggleSound(button) {
        const video = button.closest('.divine-reels__card').querySelector('video');
        const on = video.muted;
        this.querySelectorAll('video').forEach((other) => {
          if (other !== video) other.muted = true;
        });
        this.querySelectorAll('[data-reel-sound]').forEach((other) => other.setAttribute('aria-pressed', 'false'));
        video.muted = !on;
        button.setAttribute('aria-pressed', String(on));
        if (on) video.play().catch(() => {});
      }

      updateArrows() {
        const end = this.track.scrollWidth - this.track.clientWidth - 2;
        this.arrows.forEach((arrow) => {
          arrow.disabled = arrow.dataset.reelStep === '-1' ? this.track.scrollLeft <= 2 : this.track.scrollLeft >= end;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["divine-reviews"] && !Shopify.designMode) return;
  try {
    
  for (const viewport of document.querySelectorAll('.divine-reviews__viewport')) {
    const track = viewport.querySelector('.divine-reviews__track');
    const arrows = viewport.querySelectorAll('[data-divine-reviews-step]');
    if (!track || arrows.length === 0) continue;

    // „More“ card at the end of the row: shows the next batch of reviews
    const more = track.querySelector('[data-divine-reviews-more]');
    more?.addEventListener('click', () => {
      const hidden = [...track.querySelectorAll('.divine-reviews__item[hidden]')];
      const step = Number(more.dataset.divineReviewsMore) || 12;
      hidden.slice(0, step).forEach((item) => item.removeAttribute('hidden'));
      if (hidden.length <= step) more.closest('li').remove();
      update();
    });

    const update = () => {
      const end = track.scrollWidth - track.clientWidth - 2;
      for (const arrow of arrows) {
        const back = arrow.dataset.divineReviewsStep === '-1';
        arrow.disabled = back ? track.scrollLeft <= 2 : track.scrollLeft >= end;
      }
    };

    for (const arrow of arrows) {
      arrow.addEventListener('click', () => {
        const card = track.querySelector('.divine-reviews__item');
        const step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || '0') : track.clientWidth;
        track.scrollBy({ left: step * Number(arrow.dataset.divineReviewsStep), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();

    // Drag with the mouse to move the row (touch screens swipe natively)
    let drag = null;
    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      drag = { x: event.clientX, left: track.scrollLeft, moved: false };
    });
    window.addEventListener('pointermove', (event) => {
      if (!drag) return;
      const distance = event.clientX - drag.x;
      if (!drag.moved && Math.abs(distance) < 5) return;
      drag.moved = true;
      track.classList.add('divine-reviews__track--dragging');
      track.scrollLeft = drag.left - distance;
    });
    const endDrag = () => {
      if (!drag) return;
      const moved = drag.moved;
      drag = null;
      track.classList.remove('divine-reviews__track--dragging');
      if (moved) {
        // Swallow the click that follows a drag, so a link inside a card does not open
        const swallow = (event) => {
          event.preventDefault();
          event.stopPropagation();
        };
        track.addEventListener('click', swallow, { capture: true, once: true });
        setTimeout(() => track.removeEventListener('click', swallow, { capture: true }), 50);
      }
    };
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);
    track.addEventListener('dragstart', (event) => event.preventDefault());
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["divine-voucher-download"] && !Shopify.designMode) return;
  try {
    
  class DivineVoucherPicture extends HTMLElement {
    connectedCallback() {
      const query = new URLSearchParams(window.location.search);
      const values = {
        name: (query.get('n') || '').trim(),
        what: (query.get('t') || '').trim(),
        until: (query.get('v') || '').trim(),
        code: (query.get('c') || '').trim(),
      };
      if (!values.code || !this.dataset.card) {
        this.#show('[data-missing]');
        return;
      }
      const card = new Image();
      card.onload = () => this.#draw(card, values);
      card.onerror = () => this.#show('[data-missing]');
      card.src = this.dataset.card;
    }

    /** @param {string} selector */
    #show(selector) {
      const node = this.querySelector(selector);
      if (node instanceof HTMLElement) node.hidden = false;
    }

    /**
     * Same places as in the email: positions are shares of the card's width and height.
     * @param {HTMLImageElement} card
     * @param {{name: string, what: string, until: string, code: string}} values
     */
    #draw(card, values) {
      const canvas = document.createElement('canvas');
      canvas.width = card.naturalWidth;
      canvas.height = card.naturalHeight;
      const context = canvas.getContext('2d');
      if (!context) return;
      context.drawImage(card, 0, 0);
      const width = canvas.width;
      const height = canvas.height;
      const size = Math.round(width * 0.026);
      context.fillStyle = '#302B28';
      context.textBaseline = 'alphabetic';

      /**
       * @param {string} text
       * @param {number} left - share of the width where the text starts
       * @param {number} baseline - share of the height of the text's baseline
       * @param {number} right - share of the width where the line ends
       * @param {string} font
       */
      const write = (text, left, baseline, right, font) => {
        if (!text) return;
        context.font = font;
        const room = (right - left) * width;
        let line = text;
        while (line.length > 1 && context.measureText(line).width > room) line = line.slice(0, -2) + '…';
        context.fillText(line, left * width, baseline * height);
      };

      const serif = `${size}px Georgia, 'Times New Roman', serif`;
      write(values.name, 0.415, 0.2, 0.94, serif);
      write(values.what, 0.608, 0.383, 0.94, serif);
      write(values.until, 0.517, 0.555, 0.76, serif);
      write('КОД', 0.343, 0.69, 0.42, `${Math.round(size * 0.62)}px Helvetica, Arial, sans-serif`);
      write(values.code, 0.4, 0.69, 0.94, `${size}px 'Courier New', Courier, monospace`);

      const fileName = `${this.dataset.fileName || 'divine-vaucher'}-${values.code}.png`;
      canvas.toBlob((blob) => {
        if (!blob) return;
        const url = URL.createObjectURL(blob);
        const file = new File([blob], fileName, { type: 'image/png' });
        const picture = this.querySelector('[data-picture]');
        const download = this.querySelector('[data-download]');
        if (picture instanceof HTMLImageElement) {
          picture.src = url;
          picture.hidden = false;
        }
        if (download instanceof HTMLAnchorElement) {
          download.href = url;
          download.download = fileName;
          download.hidden = false;
          // Phones: the share sheet offers "Save image" to the photos; elsewhere the link downloads the file.
          download.addEventListener('click', async (event) => {
            if (!navigator.canShare || !navigator.canShare({ files: [file] })) return;
            event.preventDefault();
            try {
              await navigator.share({ files: [file] });
            } catch (error) {
              if (error instanceof Error && error.name !== 'AbortError') window.location.assign(url);
            }
          });
        }
      }, 'image/png');
      this.#show('[data-hint]');
    }
  }

  if (!customElements.get('divine-voucher-picture')) customElements.define('divine-voucher-picture', DivineVoucherPicture);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["divine-voucher"] && !Shopify.designMode) return;
  try {
    
  class DivineVoucherForm extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', (event) => {
        if (event.target instanceof HTMLInputElement && event.target.matches('[data-kind-switch]')) this.#show(event.target.value);
      });
      this.addEventListener('input', (event) => {
        if (event.target instanceof HTMLInputElement && event.target.matches('[data-count]')) this.#names();
      });
      this.addEventListener('click', (event) => {
        if (event.target instanceof HTMLElement && event.target.closest('.divine-voucher__step')) this.#names();
      });
      // Scrolling the page over a number field that still has the cursor must not change its value
      this.addEventListener(
        'wheel',
        (event) => {
          if (event.target instanceof HTMLInputElement && event.target.type === 'number' && document.activeElement === event.target) event.target.blur();
        },
        { passive: true }
      );
      this.querySelector('[data-another]')?.addEventListener('click', () => this.#step('form'));
      this.querySelector('[data-finish]')?.addEventListener('click', () => window.location.assign(this.dataset.checkout || '/checkout'));
      this.querySelector('[data-added-list]')?.addEventListener('click', (event) => {
        const remove = event.target instanceof HTMLElement ? event.target.closest('[data-added-remove]') : null;
        if (remove instanceof HTMLButtonElement && remove.dataset.key) this.#remove(remove.dataset.key, remove);
      });
      this.#names();
      this.#preselect();
      const current = this.querySelector('[data-kind-switch]:checked');
      if (current instanceof HTMLInputElement) this.#show(current.value);
      if (this.hasAttribute('data-custom-amount')) {
        // Checked in #items, so „Купи" with empty fields can still reopen the two buttons.
        const form = this.querySelector('form');
        if (form instanceof HTMLFormElement) form.noValidate = true;
        this.addEventListener('submit', (event) => this.#submit(event));
      }
      // The button starts disabled so the form cannot be sent before this script reads the amount.
      this.#enable();
      // Coming back from checkout with the browser's back button: make the button usable again.
      window.addEventListener('pageshow', this.#enable);
      // A voucher removed in the cart drawer or cart page leaves the list here too.
      document.addEventListener('shopify:cart:lines-update', this.#onCartChange);
    }

    disconnectedCallback() {
      window.removeEventListener('pageshow', this.#enable);
      document.removeEventListener('shopify:cart:lines-update', this.#onCartChange);
    }

    /** @param {Event & {promise?: Promise<unknown>}} event */
    #onCartChange = (event) => {
      if (event.target instanceof Node && this.contains(event.target)) return;
      Promise.resolve(event.promise)
        .then(() => this.#refresh())
        .catch(() => {});
    };

    /** Arriving from a service page (?therapy=<variant id>): that therapy is already chosen. */
    #preselect() {
      const wanted = new URL(window.location.href).searchParams.get('therapy');
      const select = this.querySelector('[data-kind="service"] select');
      const kind = this.querySelector('[data-kind-switch][value="service"]');
      if (!wanted || !(select instanceof HTMLSelectElement) || !(kind instanceof HTMLInputElement)) return;
      const option = Array.from(select.options).find((item) => item.value === wanted);
      if (!option) return;
      kind.checked = true;
      option.selected = true;
    }

    /** How many vouchers, kept inside the allowed range. */
    #count() {
      const field = this.querySelector('[data-count]');
      if (!(field instanceof HTMLInputElement)) return 1;
      const max = Number(field.max) || 1;
      const count = Math.min(max, Math.max(1, Math.round(Number(field.value)) || 1));
      if (String(count) !== field.value && field.value !== '') field.value = String(count);
      return count;
    }

    /** One optional name field for every voucher after the first, and the note at the limit. */
    #names() {
      const count = this.#count();
      const field = this.querySelector('[data-count]');
      const limit = this.querySelector('[data-limit]');
      if (limit instanceof HTMLElement && field instanceof HTMLInputElement) limit.hidden = count < Number(field.max);

      const holder = this.querySelector('[data-recipients]');
      const template = this.querySelector('[data-recipient-template]');
      const first = this.querySelector('[data-recipient]');
      if (!(holder instanceof HTMLElement) || !(template instanceof HTMLTemplateElement) || !(first instanceof HTMLInputElement)) return;

      const fields = () => holder.querySelectorAll('.divine-voucher__field');
      while (fields().length > count - 1) fields()[fields().length - 1].remove();
      while (fields().length < count - 1) {
        const number = fields().length + 2;
        const extra = template.content.firstElementChild?.cloneNode(true);
        if (!(extra instanceof HTMLElement)) break;
        const label = extra.querySelector('label');
        const input = extra.querySelector('input');
        if (label && input) {
          input.id = `${first.id}-${number}`;
          label.htmlFor = input.id;
          label.textContent = `${first.dataset.recipient || ''} ${number}`;
        }
        holder.append(extra);
      }
      holder.hidden = fields().length === 0;
    }

    #enable = () => {
      const button = this.querySelector('[type="submit"]');
      if (button instanceof HTMLButtonElement) button.disabled = false;
      // Vouchers already in the cart: open on the two buttons, unless a therapy was picked on a service page.
      this.#refresh().then((count) => {
        if (count > 0 && !new URL(window.location.href).searchParams.get('therapy')) this.#step('added', false);
      });
    };

    /**
     * @param {'form' | 'added'} step
     * @param {boolean} [scroll] - bring the new step into view
     */
    #step(step, scroll = true) {
      const form = this.querySelector('form');
      const done = this.querySelector('[data-done]');
      if (!(form instanceof HTMLFormElement)) return;
      form.dataset.step = step;
      if (done instanceof HTMLElement) done.hidden = step !== 'added';
      const target = step === 'added' ? this.querySelector('[data-added]') : this.querySelector('[data-kind-switch]:checked, [data-amount]');
      if (scroll && target instanceof HTMLElement) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    /** @param {string} kind - 'value' or 'service' */
    #show(kind) {
      for (const panel of this.querySelectorAll('[data-kind]')) {
        if (!(panel instanceof HTMLElement)) continue;
        const active = panel.dataset.kind === kind;
        panel.hidden = !active;
        for (const field of panel.querySelectorAll('input, select')) {
          if (field instanceof HTMLInputElement || field instanceof HTMLSelectElement) field.disabled = !active;
        }
      }
    }

    /**
     * A value voucher has one variant per whole amount (map in the product metafield
     * divine.amount_variants), so a 50 voucher is ONE item priced 50. Each voucher becomes
     * its own cart line of quantity 1, so the confirmation email gives each its own code.
     * @param {Event} event
     */
    async #submit(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      const error = this.querySelector('[data-error]');

      // Vouchers already added and nothing new typed: just show the two buttons again.
      const items = this.#untouched() && this.#hasAdded() ? [] : this.#items(form);
      if (!items) return;

      if (button instanceof HTMLButtonElement) button.disabled = true;
      if (error instanceof HTMLElement) error.hidden = true;
      try {
        if (items.length) await this.#add(items);
        this.#reset();
        await this.#refresh(items.length ? 'add' : '');
        this.#step('added');
      } catch (failure) {
        console.error('Voucher add to cart error:', failure);
        if (error instanceof HTMLElement) error.hidden = false;
      } finally {
        if (button instanceof HTMLButtonElement) button.disabled = false;
      }
    }

    /** @param {Array<object>} items */
    async #add(items) {
      const response = await fetch(this.dataset.add || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
    }

    /**
     * The browser's own bubble gets cut off under the fixed header on phones, so its message is
     * written under the field instead and the first field with a problem is brought to the middle.
     * @param {HTMLFormElement} form
     */
    #valid(form) {
      for (const note of this.querySelectorAll('[data-field-error]')) note.remove();
      const invalid = Array.from(form.elements).filter(
        (field) => (field instanceof HTMLInputElement || field instanceof HTMLSelectElement) && !field.disabled && !field.checkValidity()
      );
      for (const field of invalid) {
        if (!(field instanceof HTMLInputElement || field instanceof HTMLSelectElement)) continue;
        const note = document.createElement('p');
        note.className = 'divine-voucher__error divine-voucher__field-error';
        note.dataset.fieldError = '';
        note.setAttribute('role', 'alert');
        note.textContent = field.validationMessage;
        const box = field.closest('.divine-voucher__money, .divine-voucher__stepper') || field;
        box.insertAdjacentElement('afterend', note);
        field.addEventListener('input', () => note.remove(), { once: true });
        field.addEventListener('change', () => note.remove(), { once: true });
      }
      const first = invalid[0];
      if (first instanceof HTMLElement) {
        first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        first.focus({ preventScroll: true });
        return false;
      }
      return true;
    }

    /** True when no value, therapy or name has been entered for a new voucher. */
    #untouched() {
      const fields = this.querySelectorAll('[data-amount], [data-kind="service"] select, [data-recipient], [data-recipient-extra]');
      return Array.from(fields).every((field) => !(field instanceof HTMLInputElement || field instanceof HTMLSelectElement) || field.disabled || field.value.trim() === '');
    }

    #hasAdded() {
      const holder = this.querySelector('[data-added]');
      return holder instanceof HTMLElement && !holder.hidden;
    }

    /** Empty fields for the next voucher; the chosen kind stays. */
    #reset() {
      for (const field of this.querySelectorAll('[data-amount], [data-recipient], [data-recipient-extra]')) {
        if (field instanceof HTMLInputElement) field.value = '';
      }
      const select = this.querySelector('[data-kind="service"] select');
      if (select instanceof HTMLSelectElement) select.selectedIndex = 0;
      const count = this.querySelector('[data-count]');
      if (count instanceof HTMLInputElement) count.value = '1';
      this.#names();
    }

    /**
     * Lists the vouchers in the cart above the fields.
     * @param {'add' | 'remove' | ''} [announce] - tell the header cart and the cart drawer about the change
     * @returns {Promise<number>} how many lines the cart has
     */
    async #refresh(announce = '') {
      const holder = this.querySelector('[data-added]');
      const list = this.querySelector('[data-added-list]');
      const template = this.querySelector('[data-added-template]');
      if (!(holder instanceof HTMLElement) || !(list instanceof HTMLElement) || !(template instanceof HTMLTemplateElement)) return 0;
      let cart;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) return 0;
        cart = await response.json();
      } catch {
        return 0;
      }
      const recipientLabel = this.querySelector('[data-recipient]')?.getAttribute('data-recipient') || '';
      list.replaceChildren();
      for (const line of cart.items || []) {
        const row = template.content.firstElementChild?.cloneNode(true);
        if (!(row instanceof HTMLElement)) continue;
        const isValue = !String(line.product_title || '').startsWith('Ваучер | ');
        const amount = line.variant_title && line.variant_title !== 'Default Title' ? line.variant_title : '';
        const cents = Number(line.final_line_price) || 0;
        const price = new Intl.NumberFormat('bg-BG', {
          style: 'currency',
          currency: cart.currency || 'EUR',
          minimumFractionDigits: cents % 100 ? 2 : 0,
        }).format(cents / 100);
        // Title: the therapy, or the name of the value voucher; the price sits on the right.
        const title = isValue
          ? holder.dataset.valueLabel || amount || price
          : `${String(line.product_title).replace(/^Ваучер \| /, '')}${amount ? ` · ${amount}` : ''}`;
        const set = (selector, text) => {
          const node = row.querySelector(selector);
          if (node) node.textContent = text;
        };
        set('[data-added-title]', title);
        set('[data-added-meta]', (recipientLabel && line.properties?.[recipientLabel]) || '');
        set('[data-added-price]', `${price}${line.quantity > 1 ? ` · ${line.quantity} бр.` : ''}`);
        const titleNode = row.querySelector('[data-added-title]');
        if (titleNode instanceof HTMLElement) titleNode.title = title;
        const remove = row.querySelector('[data-added-remove]');
        if (remove instanceof HTMLButtonElement) {
          remove.dataset.key = line.key;
          remove.setAttribute('aria-label', `${remove.textContent?.trim() || ''}: ${title}`);
        }
        list.append(row);
      }
      holder.hidden = list.children.length === 0;
      // While vouchers are in the cart, the lead line and the long texts stay hidden, also when another is being chosen.
      this.closest('.divine-voucher')?.toggleAttribute('data-voucher-added', list.children.length > 0);
      const total = this.querySelector('[data-added-total]');
      if (total) {
        const cents = Number(cart.total_price) || 0;
        total.textContent = new Intl.NumberFormat('bg-BG', {
          style: 'currency',
          currency: cart.currency || 'EUR',
          minimumFractionDigits: cents % 100 ? 2 : 0,
        }).format(cents / 100);
      }
      if (announce) await this.#announce(cart, announce);
      // Last voucher removed: back to the fields.
      if (list.children.length === 0 && this.querySelector('form')?.dataset.step === 'added') this.#step('form');
      return list.children.length;
    }

    /**
     * The theme's cart (count in the header, side drawer) listens for this standard event and
     * reloads itself, so the drawer is not left empty after vouchers are added here.
     * @param {{items: Array<object>, item_count: number}} cart
     * @param {'add' | 'remove'} action
     */
    async #announce(cart, action) {
      try {
        const { CartLinesUpdateEvent } = await import('@shopify/events');
        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(new CartLinesUpdateEvent({ action, context: 'product', lines: [], promise: deferred.promise }));
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, source: 'divine-voucher', sourceId: 'divine-voucher', itemCount: cart.item_count },
        });
      } catch (error) {
        console.warn('Voucher cart update event failed:', error);
        const icon = document.querySelector('cart-icon');
        if (icon && typeof icon.renderCartBubble === 'function') icon.renderCartBubble(cart.item_count || 0, false);
      }
    }

    /**
     * @param {string} key - cart line key
     * @param {HTMLButtonElement} button
     */
    async #remove(key, button) {
      button.disabled = true;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 }),
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
      } catch (failure) {
        console.error('Voucher remove error:', failure);
      }
      await this.#refresh('remove');
    }

    /**
     * The cart lines for the voucher in the fields, or null when a field still needs filling.
     * @param {HTMLFormElement} form
     */
    #items(form) {
      if (!this.#valid(form)) return null;
      const data = new FormData(form);
      const count = this.#count();
      const recipient = this.querySelector('[data-recipient]');
      const amountField = this.querySelector('[data-amount]');
      const byAmount = amountField instanceof HTMLInputElement && !amountField.disabled;
      const id = data.get('id');
      const error = this.querySelector('[data-error]');
      if (!id) return null;

      // Each voucher carries its own name; a name left empty takes the first one.
      const firstName = recipient instanceof HTMLInputElement ? recipient.value.trim() : '';
      const extraNames = Array.from(this.querySelectorAll('[data-recipient-extra]'), (field) =>
        field instanceof HTMLInputElement ? field.value.trim() : ''
      );
      /**
       * @param {number} index - 1 for the first voucher
       * @returns {Record<string, string>}
       */
      const propertiesFor = (index) => {
        const name = (index > 1 && extraNames[index - 2]) || firstName;
        if (!(recipient instanceof HTMLInputElement) || name === '') return {};
        return { [recipient.dataset.recipient || '']: name };
      };

      const items = [];
      if (byAmount) {
        const amount = Math.round(Number(amountField.value));
        /** @type {Record<string, number>} */
        let variants = {};
        try {
          variants = JSON.parse(this.querySelector('[data-amount-variants]')?.textContent || '{}') || {};
        } catch {
          variants = {};
        }
        const variantId = variants[String(amount)];
        if (!variantId) {
          if (error instanceof HTMLElement) error.hidden = false;
          return null;
        }
        const stamp = Date.now();
        for (let index = 1; index <= count; index += 1) {
          items.push({ id: variantId, quantity: 1, properties: { ...propertiesFor(index), _voucher: `${stamp}-${index}` } });
        }
      } else {
        // One line per voucher, also for the same therapy and name: the cart has no count to show two.
        const stamp = Date.now();
        for (let index = 1; index <= count; index += 1) {
          items.push({ id, quantity: 1, properties: { ...propertiesFor(index), _voucher: `${stamp}-${index}` } });
        }
      }

      return items;
    }
  }

  if (!customElements.get('divine-voucher-form')) customElements.define('divine-voucher-form', DivineVoucherForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
